import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function splitTextToSpans(text, target) {
  // eslint-disable-next-line no-param-reassign
  target.innerHTML = '';

  const wordsAndSpaces = text.split(/(\s+)/);

  wordsAndSpaces.forEach((chunk) => {
    if (chunk.trim() === '') {
      target.appendChild(document.createTextNode(chunk));
    } else {
      const wordSpan = document.createElement('span');
      wordSpan.classList.add('word');

      chunk.split('').forEach((char) => {
        const charSpan = document.createElement('span');
        charSpan.classList.add('char');
        charSpan.textContent = char;
        wordSpan.appendChild(charSpan);
      });

      target.appendChild(wordSpan);
    }
  });
}

export default function initAnimation() {
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('article').forEach((holder) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: holder,
        start: 'top 75%',
      },
    });

    const heading = holder.querySelector('.flex-1:has(h2.text-purple)');

    if (heading) {
      const headline = heading.querySelector('h2.text-purple');
      let title;
      if (headline) {
        title = headline.textContent;
        headline.textContent = '';
      }
      const text = heading.querySelectorAll('p, .subheading');
      const btns = heading.querySelectorAll('div.flex.flex-wrap:has(.btn)');

      // eslint-disable-next-line no-extra-boolean-cast
      if (Boolean(title)) {
        splitTextToSpans(title, headline);

        tl.from(headline.querySelectorAll('.char'), {
          xPercent: -10,
          opacity: 0,
          duration: 0.1,
          stagger: 0.02,
          delay: 0.5,
          ease: 'power2.out',
        });
      }

      if (text.length) {
        tl.from(
          text,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );
      }

      if (btns.length) {
        tl.from(
          btns,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );
      }
    }
  });

  document.querySelectorAll('section').forEach((holder) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: holder,
        start: 'top 75%',
      },
    });

    const heading = holder.querySelector('header');
    const textBlock = holder.querySelectorAll('.text-block');

    if (heading) {
      const headline = heading.querySelector('h2.text-purple');
      let title;
      if (headline) {
        title = headline.textContent;
        headline.textContent = '';
      }
      const text = heading.querySelectorAll('p, .subheading');
      const btns = heading.querySelectorAll('div.flex.flex-wrap:has(.btn)');

      // eslint-disable-next-line no-extra-boolean-cast
      if (Boolean(title)) {
        splitTextToSpans(title, headline);

        tl.from(headline.querySelectorAll('.char'), {
          xPercent: -10,
          opacity: 0,
          duration: 0.1,
          stagger: 0.02,
          ease: 'power2.out',
        });
      }

      if (text.length) {
        tl.from(
          text,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );
      }

      if (btns.length) {
        tl.from(
          btns,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );
      }
    }

    textBlock.forEach((heading2) => {
      const headline = heading2.querySelector('h2');

      let title;
      if (headline) {
        title = headline.textContent;
        headline.textContent = '';
      }
      const text = heading2.querySelectorAll('p, ul, h3');
      const btns = heading2.querySelectorAll('div.flex.flex-wrap:has(.btn)');

      // eslint-disable-next-line no-extra-boolean-cast
      if (Boolean(title)) {
        splitTextToSpans(title, headline);

        tl.from(headline.querySelectorAll('.char'), {
          xPercent: -10,
          opacity: 0,
          duration: 0.1,
          stagger: 0.02,
          ease: 'power2.out',
        });
      }

      if (text.length) {
        tl.from(
          text,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );
      }

      if (btns.length) {
        tl.from(
          btns,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );
      }
    });

    const lineCards = holder.querySelectorAll('.js-line-card');
    lineCards.forEach((card) => {
      const tl2 = gsap.timeline();

      const icon = card.querySelector('.js-icon');
      const cardTitle = card.querySelector('h4');

      let titletxt;
      if (cardTitle) {
        titletxt = cardTitle.textContent;
        cardTitle.textContent = '';
      }
      const descr = card.querySelectorAll('p');

      icon &&
        tl2.from(icon, {
          x: -100,
          duration: 0.6,
          ease: 'power2.out',
        });

      // eslint-disable-next-line no-extra-boolean-cast
      if (Boolean(titletxt)) {
        splitTextToSpans(titletxt, cardTitle);

        tl2.from(
          cardTitle.querySelectorAll('.char'),
          {
            xPercent: -10,
            opacity: 0,
            duration: 0.1,
            stagger: 0.02,
            ease: 'power2.out',
          },
          '<'
        );
      }

      if (descr.length) {
        tl2.from(
          descr,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '<'
        );
      }

      tl.add(tl2, 1.2);
    });

    holder.querySelectorAll('.quote-box').forEach((quoteBox) => {
      if (quoteBox.closest('.tab-content')) return;

      const icon = quoteBox.querySelector('.quote-box-icon');
      const quote = quoteBox.querySelector('p');
      const cite = quoteBox.querySelector('cite');
      const img = quoteBox.querySelector('img');
      let titletxt;
      const tl3 = gsap.timeline();

      if (quote) {
        titletxt = quote.textContent;
        quote.textContent = '';
      }

      icon &&
        tl3.from(icon, {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
        });

      // eslint-disable-next-line no-extra-boolean-cast
      if (Boolean(titletxt)) {
        splitTextToSpans(titletxt, quote);

        tl3.from(
          quote.querySelectorAll('.char'),
          {
            xPercent: -10,
            opacity: 0,
            duration: 0.1,
            stagger: 0.01,
            ease: 'power2.out',
          },
          '>'
        );
      }

      cite &&
        tl3.from(
          cite,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );

      img &&
        tl3.from(
          img,
          {
            xPercent: 30,
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );

      tl.add(tl3, heading ? 1 : 0);
    });

    holder.querySelectorAll('.count-box').forEach((quoteBox) => {
      const boxTitle = quoteBox.querySelectorAll('.count-box-title');
      const txt = quoteBox.querySelectorAll('p');
      const tl4 = gsap.timeline();

      boxTitle.forEach((btitle) => {
        tl4.from(
          btitle.querySelectorAll('span'),
          {
            xPercent: -50,
            opacity: 0,
            duration: 0.3,
            stagger: 0.03,
            ease: 'power2.out',
          },
          '>'
        );

        tl4.from(
          btitle.querySelectorAll('sup'),
          {
            xPercent: -50,
            opacity: 0,
            duration: 0.3,
            stagger: 0.02,
            ease: 'power2.out',
          },
          '>'
        );
      });

      txt &&
        tl4.from(
          txt,
          {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
          },
          '>'
        );

      tl.add(tl4, 1.2);
    });
  });

  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500);

  const items = document.querySelectorAll('.decor-parallax');

  items.forEach((item) => {
    gsap.to(item, {
      yPercent: -250,
      ease: 'none',
      scrollTrigger: {
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1,
      },
    });
  });
}
